<template>
  <div class="card mb-4">
    <div class="card-body">
      <div class="row">
        <div class="col">
          <h4>{{ 'installation_note' | t }}</h4>
        </div>
        <div class="col-auto text-right">
          <button class="btn btn-outline-primary btn-sm" @click="emitOpenModal">
            {{ 'edit' | t }}
          </button>
        </div>
      </div>
      <hr />
      <em>
        <pre class="pre-wrap note-wrap">{{ customer.installation_note }}</pre>
      </em>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    customer: Object
  },
  methods: {
    emitOpenModal() {
      this.$emit('openModal');
    }
  }
};
</script>

<style scpped>
.note-wrap {
  text-wrap: pretty;
}
</style>
